import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'

import { normalizeApprovalListPaginationCursors } from 'features/AdsManagement/helpers/normalizeApprovalListCursor'
import { postApprovalSubmissionsListAPI } from 'features/AdsManagement/services/principalList'

import { AdsApprovalSubmissionsParamInterface } from 'features/AdsManagement/@types/apiTypes'

import { setIsLoading, setPrincipalDetail, setPagination, SLICE_NAME } from './slice'

export const fetchPrincipalDetailList = createAsyncThunk(
  `${SLICE_NAME}/fetchPrincipalDetailList`,
  async (
    { params }: { params: AdsApprovalSubmissionsParamInterface },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsLoading(true))
    try {
      const response = await postApprovalSubmissionsListAPI(params)

      dispatch(setPrincipalDetail(response.data.data.approval_submissions))
      dispatch(setPagination(normalizeApprovalListPaginationCursors(response.data.pagination)))
      dispatch(setIsLoading(false))

      return true
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
